// Pinia state machine para o ciclo de vida da chamada WAVOIP (outbound-only).
// Espelha o shape option-style do `app/javascript/dashboard/stores/calls.js`
// upstream sem getters extras: o composable `useWavoipCallSession` muta o
// store via actions; a Phase 4 widget lê `status` / `startedAt` direto.
// Origem: ADR 0007.

import { defineStore } from 'pinia';

export const useWavoipCallsStore = defineStore('wavoipCalls', {
  state: () => ({
    status: 'idle', // 'idle' | 'dialing' | 'in_call'
    phone: null,
    contactId: null,
    startedAt: null, // ms timestamp; populated on peerAccept (Phase 4 Timer reads)
  }),

  actions: {
    setDialing(phone, contactId) {
      this.status = 'dialing';
      this.phone = phone;
      this.contactId = contactId;
      this.startedAt = null;
    },
    setInCall() {
      this.status = 'in_call';
      this.startedAt = Date.now();
    },
    reset() {
      this.$reset();
    },
  },
});
